module.exports = __webpack_public_path__ + "img/25.a988655e.jpg";